export const fastClone = <T extends object>(obj: T): T =>
  JSON.parse(JSON.stringify(obj));

export type Size = 'large' | 'medium' | 'small' | 'xsmall';
export const sizeNames: Size[] = ['xsmall', 'small', 'medium', 'large'];

const sizes = {
  xsmall: {
    min: 0,
    default: 0,
    max: 0,
  },
  small: {
    min: 320,
    default: 321,
    max: 640,
  },
  medium: {
    min: 641,
    default: 642,
    max: 991,
  },
  large: {
    min: 990,
    default: 991,
    max: 1200,
  },
  getWidthForSize(size: Size) {
    return this[size].default;
  },
  getSizeForWidth(width: number) {
    for (const size of sizeNames) {
      const value = this[size];
      if (width <= value.max) {
        return size;
      }
    }
    return 'large';
  },
};
export type Sizes = typeof sizes;

export interface Breakpoints {
  small?: number;
  medium?: number;
}

export const getSizesForBreakpoints = ({ small, medium }: Breakpoints) => {
  const newSizes = {
    ...sizes,
    ...fastClone(sizes),
  };

  if (!small || !medium) {
    return newSizes;
  }

  const smallMin = Math.floor(small / 2);
  newSizes.small = {
    max: small,
    min: smallMin,
    default: smallMin + 1,
  };

  const mediumMin = newSizes.small.max + 1;
  newSizes.medium = {
    max: medium,
    min: mediumMin,
    default: mediumMin + 1,
  };

  const largeMin = newSizes.medium.max + 1;
  newSizes.large = {
    max: 2000,
    min: largeMin,
    default: largeMin + 1,
  };

  return newSizes;
};
